export function isPreviewCrawler(userAgent: string): boolean {
  return !userAgent || /bot|crawler|spider|facebookexternalhit|facebookcatalog|facebot|meta-external(?:agent|fetcher|ads)|slack|linkedin|twitter|discord|pinterest|whatsapp|telegram|preview/i.test(userAgent);
}

/** Redirect humans only to the browser tracking hop, after campaign validation. */
export function setShortLinkHttpRedirect(
  request: Pick<Request, 'method' | 'headers'> | null, response: ResponseInit | null, redirectUrl: string,
  goUrl: string, isPreview: boolean,
): boolean {
  if (!request || !response || isPreview || request.method !== 'GET' || !redirectUrl) return false;
  const headers = new Headers(response.headers);
  const vary = headers.get('Vary');
  headers.set('Vary', vary ? `${vary}, User-Agent` : 'User-Agent');
  headers.set('Cache-Control', 'private, no-store, max-age=0');
  response.headers = headers;
  const userAgent = request.headers.get('User-Agent') ?? '';
  if (isPreviewCrawler(userAgent)) return false;
  let target: URL;
  try { target = new URL(redirectUrl, goUrl); } catch { return false; }
  if (target.origin !== new URL(goUrl).origin || target.pathname !== '/share-click') return false;
  // A relative Location also works behind local proxies/custom hosting domains.
  response.status = 302;
  headers.set('Location', `${target.pathname}${target.search}${target.hash}`);
  return true;
}
